var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4199_1113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8355 0C8.80443 0 0.671781 8.06906 0.671781 18.0236C0.671781 21.4288 1.6242 24.6134 3.27822 27.3304L0 37L10.0564 33.8053C12.6586 35.2328 15.6514 36.0472 18.8355 36.0472C28.8678 36.0472 37 27.977 37 18.0236C37 8.06906 28.8678 0 18.8355 0ZM27.8676 24.8685C27.4403 25.9278 25.5077 26.8946 24.655 26.9391C23.8031 26.9843 23.7789 27.5994 19.1347 25.5819C14.4911 23.5639 11.6974 18.6572 11.4771 18.3413C11.2567 18.0264 9.67831 15.7771 9.76346 13.5135C9.84918 11.2495 11.0888 10.1814 11.5312 9.73711C11.9731 9.2922 12.4798 9.2125 12.7892 9.20747C13.1549 9.20152 13.3918 9.19656 13.6624 9.20656C13.9328 9.2168 14.339 9.14998 14.6907 10.0852C15.0422 11.0204 15.8835 13.3188 15.9911 13.5531C16.0986 13.7875 16.1652 14.059 15.9995 14.36C15.8334 14.6617 15.7483 14.8502 15.5072 15.1102C15.2648 15.3702 14.9973 15.6918 14.7811 15.8906C14.5399 16.1107 14.288 16.3508 14.5416 16.8213C14.795 17.2915 15.6692 18.8328 17.001 20.1031C18.7127 21.7359 20.1888 22.2775 20.643 22.5243C21.0985 22.7724 21.3703 22.7448 21.6528 22.4476C21.9339 22.1504 22.8618 21.1472 23.1886 20.6993C23.5152 20.2501 23.8213 20.3381 24.2409 20.5069C24.6603 20.6764 26.8968 21.8743 27.3523 22.1216C27.8074 22.3685 28.1116 22.4957 28.2203 22.6915C28.3291 22.8881 28.2948 23.809 27.8676 24.8685Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4199_1113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.b25a5f0c0ab9f35f60774ec1c20fddaf.svg";
export { ForwardRef as ReactComponent };